import React, { Component } from "react";
import { aprsLogbookFind } from "../common/ApiUtils";
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
} from "@ionic/react";
import {
  addTimeArr,
  addZero,
  dayConvertToHuman,
  reverseDateToLocalDate,
} from "../common/TimeUtils";
import "./AprsLogbookContent.css";
import AprsLogbookRow from "./AprsLogbookRow";

const identifierOrKey = (record) =>
  record.identifier && record.identifier.trim().length > 0 ? record.identifier : record.key;

const takeOffMs = (record) => {
  if (!record?.takeOff) return 0;
  const t = new Date(record.takeOff).getTime();
  return Number.isFinite(t) ? t : 0;
};

const sortGroupsByDayDesc = (groups) =>
  [...groups].sort((a, b) => String(b[0]?.day ?? "").localeCompare(String(a[0]?.day ?? "")));

const sortFlightsByTakeOffDesc = (flights) =>
  [...flights].sort((a, b) => takeOffMs(b) - takeOffMs(a));

const totalTime = (group) => {
  let time = [0, 0];
  for (let i = 0; i < group.length; i++) {
    const t = group[i].duration;
    if (t) {
      time = addTimeArr(t, time);
    }
  }
  return time[0] + ":" + addZero(time[1].toString());
};

class AprsLogbookContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entityList: [],
      search: "",
      disableInfiniteScroll: false,
      scrollPage: 0,
      place: props.place,
    };
    this.searchChange = this.searchChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.place !== this.props.place ||
      nextProps.identifier !== this.props.identifier ||
      nextProps.day !== this.props.day
    ) {
      this.setState({ place: nextProps.place, scrollPage: 0, disableInfiniteScroll: false });
      this.loadEntityResource({
        place: nextProps.place,
        identifier: nextProps.identifier,
        date: nextProps.day,
      });
    }
  }

  componentDidMount() {
    this.loadEntityResource();
  }

  async loadEntityResource(data) {
    const { scrollPage, place } = this.state;
    const { identifier, day } = this.props;
    const dayFormatted = day ? reverseDateToLocalDate(day) : null;
    let message = { page: scrollPage, identifier, place, date: dayFormatted };
    if (data) {
      const dayFormattedData = data.date ? reverseDateToLocalDate(data.date) : null;
      message = { page: 0, identifier: data.identifier, place: data.place, date: dayFormattedData };
    }

    const resource = await aprsLogbookFind(message);
    if (resource) {
      this.setState({ entityList: resource });
    }
  }

  async loadEntityNext() {
    const { scrollPage, entityList, place } = this.state;
    const { identifier, day } = this.props;
    const dayFormatted = day ? reverseDateToLocalDate(day) : null;
    const message = { page: scrollPage + 1, identifier, place, date: dayFormatted };
    const resource = await aprsLogbookFind(message);
    if (resource) {
      const list = resource;
      if (list && list.length >= 100) {
        this.setState({
          scrollPage: scrollPage + 1,
          entityList: [...entityList, ...list],
        });
      } else {
        this.setState({ disableInfiniteScroll: true });
      }
    }
  }

  searchChange(e) {
    this.setState({ search: e.target.value });
  }

  async pageNext(e) {
    await this.loadEntityNext();
    e.target.complete();
  }

  groupByDay(list) {
    const grouped = [];
    let dayList = [];
    let lastDay = "";
    for (let i = 0; i < list.length; i++) {
      if (list[i].day !== lastDay) {
        if (dayList.length !== 0) {
          grouped.push(dayList);
          dayList = [];
        }
        lastDay = list[i].day;
      }
      if (list[i].identifier) {
        if (list[i].identifier.startsWith("OE") || list[i].identifier.startsWith("D")) continue;
      }
      dayList.push(list[i]);
    }
    if (dayList.length !== 0) {
      grouped.push(sortFlightsByTakeOffDesc(dayList));
    }
    return sortGroupsByDayDesc(grouped);
  }

  placeOrAnchor = (pl) => {
    if (!pl) return pl;
    const i = pl.indexOf(" ");
    if (i < 0) {
      return (
        <span
          onClick={(e) => {
            e.stopPropagation();
            this.props.setPlace(pl);
          }}
        >
          {pl}
        </span>
      );
    }
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://mapy.cz/zakladni?z=17&q=" + pl}
        title={pl}
        onClick={(e) => e.stopPropagation()}
      >
        GPS
      </a>
    );
  };

  render() {
    const { entityList, search, disableInfiniteScroll } = this.state;
    const { findFce, filterFce } = this.props;
    let list = entityList;
    if (filterFce) {
      list = list.filter(filterFce);
    }

    return (
      <>
        <IonList lines="none" className="aprs-logbook-list">
          {list &&
            (!findFce || (findFce && !search)) &&
            this.groupByDay(list).map((group) => (
              <div key={group[0]?.day ?? group[0]?.id} className="aprs-day-block">
                <div className="aprs-day-block__title">{dayConvertToHuman(group.at(0).day)}</div>
                <div className="aprs-table-wrap">
                  <table className="aprs-table">
                    <thead>
                      <tr>
                        <th>Identifikátor</th>
                        <th>Vzlet</th>
                        <th>Přistání</th>
                        <th className="aprs-th-dur">Doba</th>
                        <th>Místo vz.</th>
                        <th>Místo př.</th>
                        <th className="aprs-th-expand" aria-label="Rozbalit" />
                      </tr>
                    </thead>
                    <tbody>
                      {group.map((record, rowIndex) => (
                        <AprsLogbookRow
                          key={record.id}
                          record={record}
                          rowIndex={rowIndex}
                          setIdentifier={this.props.setIdentifier}
                          placeOrAnchor={this.placeOrAnchor}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.props.identifier && group.length > 0 && (
                  <div className="aprs-day-block__total">
                    Celkem {group.length}× · {totalTime(group)}
                  </div>
                )}
              </div>
            ))}
        </IonList>
        <IonInfiniteScroll
          threshold="100px"
          disabled={disableInfiniteScroll}
          onIonInfinite={(e) => this.pageNext(e)}
        >
          <IonInfiniteScrollContent loadingText="Načítám další …" />
        </IonInfiniteScroll>
      </>
    );
  }
}

export default AprsLogbookContent;
